export const COMPETITOR_DNI_PARAM = 'competitor_dni';

export const normalizeDni = (value) => {
    if (!value) return '';
    return String(value).replace(/\D/g, '');
};

export const isValidDni = (value) => /^\d{7,10}$/.test(value);

export const getCompetitorDniFromSearch = (searchParams) => {
    if (!searchParams) return '';
    const raw =
        searchParams.get(COMPETITOR_DNI_PARAM) ??
        searchParams.get('dni') ??
        searchParams.get('competitorDni');
    const dni = normalizeDni(raw);
    return isValidDni(dni) ? dni : '';
};

export const hasInvalidCompetitorParam = (searchParams) => {
    if (!searchParams) return false;
    const hasParam =
        searchParams.has(COMPETITOR_DNI_PARAM) ||
        searchParams.has('dni') ||
        searchParams.has('competitorDni');
    if (!hasParam) return false;
    return !getCompetitorDniFromSearch(searchParams);
};
